// Sample card from Airbnb
import React, {useState, useEffect} from "react";
import classes from "../styles.module.css"; 
import { useNavigate, useParams } from "react-router-dom";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs"
import UploadCvService from "../../../services/uploadCV.service";
import swal from 'sweetalert';
import APIConfig from "../../../api/APIConfig";
import validator from 'validator'

import {
    Box,
    Center,
    FormControl,
    Icon,
    Input,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';

const checkUrlDokumen = value => {
    if (value.length > 0 && !validator.isURL(value)) {
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            URL tidak valid!
        </div>
    }
};

const EditDokumen = (props) => {
    let navigate = useNavigate();

    const [selectedFiles2, setSelectedFiles2] = useState(undefined);
    const [fileInfo2, setFileInfo2] = useState([]);
    const [idCV, setIdCV] = useState('');
    const [name2, setName2] = useState('');
    const [url2, setUrl2] = useState('');

    const [urlDokumen, setUrlDokumen] = useState('');
    const [urlDokumen2, setUrlDokumen2] = useState('');
    const [idUrl, setIdUrl] = useState(undefined);

    const { id } = useParams();

    const getCV = async() => {
        const response = await APIConfig.get(`/v1/cv/file/${id}`);
        const result = await response.data;
        setFileInfo2(result);
    };

    const getUrl = async(idUrl) => {
        const response = await APIConfig.get(`/v1/urlDokumen/${idUrl}`);
        const result = await response.data;
        setUrlDokumen(result.urlDokumen);
        setUrlDokumen2(result.urlDokumen);
        setIdUrl(result.idUrlDokumen);
    };

    useEffect(() => {
        getCV();
        getUrl(id);
    }, []);

    function selectFiles2(even){
        setSelectedFiles2(even.target.files);
    }

    function upload2(idx, file) {
        UploadCvService.upload(file, (event) => {}, id)
        .then((files) => { 
            const result = files.data
            setIdCV(result.id);
            setName2(result.name);
            setUrl2(result.url);
        })
        .then(() => {
            console.log("berhasil") 
            navigate(`/peserta/dokumen/${id}`);

        })
    }

    const uploadUrlDokumen = async (e) => {
        console.log("masuk")        
    
        await APIConfig.post(`/v1/urlDokumen/${id}`, {
            urlDokumen: urlDokumen,
        })
        .then(() => {
            console.log("berhasil") 
            navigate(`/peserta/dokumen/${id}`);

        })
        .catch((error) => {
            console.log(error);

        })
        
    };

    const updateUrlDokumen = async (e) => {
        console.log("masuk")        
        await APIConfig.put(`/v1/urlDokumen/${id}`, {
            urlDokumen: urlDokumen2,
        })
        .then(() => {
            console.log("berhasil") 
            navigate(`/peserta/dokumen/${id}`);

        })
        .catch((error) => {
            console.log(error);
        })
        
    };

    function uploadFiles2() {
        for (let i = 0; i < selectedFiles2.length; i++) {
            upload2(i, selectedFiles2[i]);
        }
        
    }

    function confirmDeleteCV (id) {
        swal({
            title: "Yakin ingin menghapus CV ini?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
              deleteCV(id);
            } 
        });
    }

    const deleteCV = async (idCv) => {
        console.log("masuk")  
        await APIConfig.delete(`v1/cv/delete/${idCv}`)
        .then(() => {
            console.log("berhasil") 
            navigate(`/peserta/dokumen/edit/${id}`);
            window.location.reload();
        })
        .catch((error) => {
            console.log(error);
        })    
    };

    function submit() {
        if(fileInfo2.length === 0 && selectedFiles2 === undefined ) {
            swal({
                title: "Gagal",
                text: "Anda perlu meng-upload CV anda!",
                icon: "error",
                button: "OK",
              });
            return;
        }
       if(selectedFiles2 === undefined && fileInfo2 !== null) {
            if(urlDokumen.length > 0) {
                if(idUrl === undefined) uploadUrlDokumen();
                else updateUrlDokumen();

                swal({
                    title: "Berhasil",
                    icon: "success",
                    button: "OK",
                  });
            }
            else {
                return;
            }
        }
        else if(selectedFiles2 !== null) {
            uploadFiles2();
            if(urlDokumen.length > 0){
                if(idUrl === undefined) uploadUrlDokumen();
                else updateUrlDokumen();
                swal({
                    title: "Berhasil",
                    icon: "success",
                    button: "OK",
                  });
            }
            else {
                return;
            }
        }
        else {
            return;
        }
    }

    return (
        <div>
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={'50px'}
                align='stretch'
                >
                    <Text
                        pt={5}
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={650}
                        fontSize={'3xl'}>
                        Dokumen Peserta
                    </Text>

                    {fileInfo2.length !== 0 ? 
                    <div>
                        <h3 className={classes.h} >Curriculum Vitae</h3>
                        <div>
                            <HStack pt={5} pb={5}>
                                <Icon mr="5px" fontSize={'xl'} as={BsFillFileEarmarkPdfFill} />
                                <a href={fileInfo2.url} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{fileInfo2.name}</p>
                                </a>
                                <Button p={3} w='10%' rounded={'xl'} colorScheme='purple' variant='solid'
                                onClick={() => confirmDeleteCV(fileInfo2.id)}>
                                    Hapus
                                </Button>
                            </HStack>
                        </div>
                    </div>
                    :
                    <div>
                        <h3 className={classes.h} >Curriculum Vitae</h3>
                            <Text fontSize={13} color={'gray.400'}>Unggah Curriculum Vitae dengan format PDF</Text>
                            <HStack pt={5} pb={5}>
                                <Icon mr="5px" fontSize={'xl'} as={BsFillFileEarmarkPdfFill} />
                            </HStack>
                            <FormControl isRequired fontFamily={'Inter'}>
                                <input id='cv' 
                                    className="custom-file-input" 
                                    type='file' 
                                    multiple 
                                    onChange={selectFiles2} 
                                    placeholder="Pilih file" 
                                    accept="pdf/*"/>
                            </FormControl>
                    </div>}

                    {idUrl !== undefined ? 
                    <FormControl pb={6} fontFamily={'Inter'} >
                        <h3 className={classes.h}>URL Dokumen Tambahan (Optional)</h3>
                        <Input 
                            id='urlDokumen2' 
                            placeholder='Masukkan URL dokumen tambahan'
                            value={urlDokumen2}
                            validations={[checkUrlDokumen]}
                            onChange={(e) => setUrlDokumen2(e.target.value)}
                        />
                    </FormControl>
                    :
                    <FormControl pb={6} fontFamily={'Inter'} >
                    <h3 className={classes.h}>URL Dokumen Tambahan (Optional)</h3>
                    <Input 
                        id='urlDokumen' 
                        placeholder='Masukkan URL dokumen tambahan'
                        validations={[checkUrlDokumen]}
                        onChange={(e) => setUrlDokumen(e.target.value)}
                    />
                </FormControl>
                }
            </VStack>
            <Center pt={20}>
                <Button 
                    onClick={submit}
                    p={6} w='30%' rounded={'xl'} colorScheme='purple' variant='solid'>
                        Simpan
                </Button>
            </Center>
            </Box>
        </VStack>
        </Center>
        </div>
      );
  }

export default EditDokumen;